<template>
  <div class="carousel-card px-0">
    <div class="d-flex">
      <div class="carousel-container">
        <button
          v-if="detail && detail.length > 1"
          class="carousel-btn left"
          @click="prevSlide"
        >
          <i class="fa-solid fa-chevron-left"></i>
        </button>

        <!-- <transition :name="transitionName" mode="out-in"> -->
          <div class="row px-3" :key="currentIndex">
            <div 
              class="col-12 col-md-6 px-2" 
              v-for="(cardInfo, subIndex) in paginatedDetails[currentIndex]" 
              :key="subIndex"
            >
              <div class="bg-card shadow rounded border">
                <div class="row p-0">
                  <div class="col-md-6">
                    <div class="image-container bg-icon-primary">
                      <div v-if="isLoadingImages" class="image-loader">
                        <div class="spinner"></div>
                      </div>
                      <img v-if="cardInfo.img" :src="cardInfo.img" :alt="cardInfo.tittle || 'Artículo del blog'" class="carousel-image" width="800" height="450" loading="lazy" decoding="async" @load="handleImageLoad" />
                      <div v-if="!cardInfo.img || cardInfo.img == ''">
                        <div class="circle bg-icon-primary big">
                          <i class="fa-solid fa-image primary"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 p-0">
                    <div class="content-container py-4 pr-lg-5">
                      <div class="px-md-0 px-lg-0 px-5">
                        <span><b>{{ cardInfo.date }}</b></span>
                        <h4 class="text-primary">{{ cardInfo.tittle.length > 15 ? cardInfo.tittle.substring(0, 15) + "..." : cardInfo.tittle }}</h4>
                        <p class="text-secondary pb-0">
                          {{ stripHtmlTags(cardInfo.detail).length > 70 
                              ? stripHtmlTags(cardInfo.detail).substring(0, 70) + '...' 
                              : stripHtmlTags(cardInfo.detail)
                          }}
                        </p>
                        <router-link :to="cardInfo.ruta || `/blog/${cardInfo.id}`" class="btn btn-primary btn-pill">{{ $t('blog.readMore') }}</router-link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        <!-- </transition> -->

        <button
          v-if="detail && detail.length > 1"
          class="carousel-btn right"
          @click="nextSlide"
        >
          <i class="fa-solid fa-chevron-right"></i>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["cardInfo", "detail"],
  data() {
    return {
      currentIndex: 0,
      transitionName: "slide-left",
      isLoadingImages: true,
    };
  },
  computed: {
    paginatedDetails() {
      if (!this.detail || this.detail.length === 0) return [];
      let result = [];
      for (let i = 0; i < this.detail.length - 1; i++) {
        result.push([this.detail[i], this.detail[i + 1]]);
      }
      if (this.detail.length === 1) {
        result.push([this.detail[0]]);
      }
      return result;
    },
  },
  methods: {
    handleImageLoad() {
      this.isLoadingImages = false;
    },
    stripHtmlTags(text) {
      const div = document.createElement("div");
      div.innerHTML = text;
      return div.textContent || div.innerText || "";
    },
    nextSlide() {
      this.transitionName = "slide-left";
      this.currentIndex = (this.currentIndex + 1) % this.paginatedDetails.length;
    },
    prevSlide() {
      this.transitionName = "slide-right";
      this.currentIndex = (this.currentIndex - 1 + this.paginatedDetails.length) % this.paginatedDetails.length;
    },
  },
};
</script>

<style scoped>
.image-container {
  width: 100%;
  height: 16rem;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: var(--radius);
}
.image-container img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.carousel-card {
  height: 100% !important;
  position: relative;
  width: 100%;
  border-radius: var(--radius);
  overflow: hidden;
}

.carousel-container {
  position: relative;
  width: 100%;
}

.carousel-btn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: var(--primary);
  color: #fff;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  transition: background-color 0.2s;
}

.carousel-btn:hover {
  background-color: var(--primary-light);
}

.carousel-btn.left {
  left: 10px;
}

.carousel-btn.right {
  right: 10px;
}

.slide-left-enter-active,
.slide-left-leave-active,
.slide-right-enter-active,
.slide-right-leave-active {
  transition: transform 0.5s ease-in-out, opacity 0.3s ease-in-out;
}

.slide-left-enter {
  opacity: 0;
  transform: translateX(100%);
}

.slide-left-leave-to {
  opacity: 0;
  transform: translateX(-100%);
}

.slide-right-enter {
  opacity: 0;
  transform: translateX(-100%);
}

.slide-right-leave-to {
  opacity: 0;
  transform: translateX(100%);
}

.circle.big {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.image-loader {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: var(--primary-dark);
  z-index: 5;
}

.spinner {
  width: 40px;
  height: 40px;
  border: 4px solid rgba(255, 255, 255, 0.3);
  border-top-color: var(--primary);
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.image-container {
  position: relative;
}
</style>



 
